'use client';
import type { ChildrenProps } from '@viewup/ui';
import { useEffect } from 'react';
import { useEventStore } from './store';
import type { EventState } from './types';

type Props = ChildrenProps & {
  activeEvent: EventState['activeEvent'];
  meta: EventState['meta'];
};

export const EventStoreBootstrap = ({ activeEvent, meta, children }: Props) => {
  useEffect(() => {
    useEventStore.setState({ activeEvent, meta } as EventState);
  }, [activeEvent, meta]);

  return <>{children}</>;
};
